import * as POKEMON from "./pokemon";

const { PIKACHU, ...WILD_POKEMON } = POKEMON;

export { POKEMON, WILD_POKEMON };
